import { useContext } from "react";
import { t } from "ttag";

import { getNewTabTitle } from "metabase/common/components/ExternalLink";
import { ForwardRefLink } from "metabase/common/components/Link";
import { ActionIcon, FixedSizeIcon, Tooltip } from "metabase/ui";

import { TOOLTIP_OPEN_DELAY_MS } from "../../../constants";
import { GraphContext } from "../GraphContext";

type GraphExternalLinkProps = {
  label: string;
  url: string;
  isCompact?: boolean;
};

export function GraphExternalLink({
  label,
  url,
  isCompact,
}: GraphExternalLinkProps) {
  const { openLinksInNewTab } = useContext(GraphContext);
  // Icon-only, so `aria-label` (updated for real screen readers) and
  // `title` (what the automated a_target_warning checker actually reads)
  // both need the warning -- see ExternalLink's NewTabWarning for why.
  const accessibleLabel = openLinksInNewTab
    ? t`${label} (opens in a new tab)`
    : label;

  return (
    <Tooltip label={label} openDelay={TOOLTIP_OPEN_DELAY_MS}>
      <ActionIcon
        component={ForwardRefLink}
        to={url}
        target={openLinksInNewTab ? "_blank" : undefined}
        title={openLinksInNewTab ? getNewTabTitle() : undefined}
        m={isCompact ? "-sm" : undefined}
        aria-label={accessibleLabel}
      >
        <FixedSizeIcon name="external" />
      </ActionIcon>
    </Tooltip>
  );
}
